"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ActionButton = _interopRequireDefault(require("../ActionButton"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * `SummaryButton` is a component to render a short summary with an action button. It's initial use case is a summary of table contents with action to load more items.
 */
const SummaryButton = _ref => {
  let {
    className,
    isLoading,
    summary,
    label,
    onClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("small", {
    className: className
  }, summary && /*#__PURE__*/_react.default.createElement("span", {
    className: "u-text--muted"
  }, summary), onClick && /*#__PURE__*/_react.default.createElement(_ActionButton.default, {
    className: (0, _classnames.default)("is-small", "is-dense", {
      "is-inline": summary
    }),
    onClick: onClick,
    loading: isLoading,
    disabled: isLoading
  }, label));
};
var _default = exports.default = SummaryButton;